import { PureComponent, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Icon, Radio, Modal } from 'semantic-ui-react';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import moment from 'moment';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  List,
  Heading,
} from 'ckeditor5';

import { CustomAccordion, CustomTable } from '../../../../components';
import { find, isEmpty, map, get } from '../../../../utils/lodash';

import {
  postActivityType,
  getEventTypes,
  getOutputFormatGroups,
  getEventDetails,
  updateActivityType,
} from '../../../../store/actions';

import '../../admin.scss';

class ParentEventDetails extends Component {
  componentDidMount() {
    const { getEventDetails, getOutputFormatGroups } = this.props;
    getEventDetails({ all: true });
    getOutputFormatGroups('all');
  }

  render() {
    return (
      <div className="event-details-segment pb-3">
        <EventDetailsCreate {...this.props} />

        <EventDetailsList {...this.props} />
      </div>
    );
  }
}

export class EventDetailsList extends Component {
  render() {
    const { eventTypes } = this.props;
    return (
      <div className="accordion-container">
        {map(eventTypes, (eventType, i) => {
          return (
            <div key={i} className="gap-between-windows-help">
              <CustomAccordion
                title={eventType.type}
                children={
                  <ActivityDetailsBase eventType={eventType} {...this.props} />
                }
              />
            </div>
          );
        })}
      </div>
    );
  }
}

class ActivityDetailsBase extends Component {
  constructor(props) {
    super(props);
    const { t, i18n } = this.props;

    this.columns = [
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.type')}</strong>
          </div>
        ),
        render: (data) => {
          return <div>{data.detail}</div>;
        },
        width: 9,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.created_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div>
              {new Intl.DateTimeFormat(i18n.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              }).format(new Date(data.createdAt))}
            </div>
          );
        },
        width: 3,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.updated_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div>
              {new Intl.DateTimeFormat(i18n.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              }).format(new Date(data.updatedAt))}
            </div>
          );
        },
        width: 3,
      },
      {
        title: '',
        render: (data) => {
          return <EditActivityDetails form={data} {...this.props} />;
        },
        width: 1,
      },
    ];
  }

  render() {
    const { t, eventType } = this.props;

    return (
      <div className="activity-details-segment">
        <CustomTable
          header
          customClass="super-admin-table tbody-hover"
          columns={this.columns}
          data={eventType.activityDetails}
          emptyMessage={t(
            'admin.activity_settings.activity_types.no_activity_details'
          )}
          keyExtractor={(item, index) => item.id}
        />
      </div>
    );
  }
}

export const ActivityDetails = withTranslation()(ActivityDetailsBase);

class EditActivityDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {},
    };
  }

  editSelected(form) {
    this.setState({
      form,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal, form } = this.state;
    const { t } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <label
            className="activity-actions-warn mb-0"
            onClick={() => this.editSelected(form)}
          >
            {t('actions.edit')}
          </label>
        }
        className="edit-activity-details"
      >
        <Modal.Header>
          {t('admin.activity_settings.activity_types.edit_activity_details')}
        </Modal.Header>
        <Modal.Content>
          <ActivityForm
            isEdit={true}
            toggle={() => this.toggle()}
            form={form}
            {...this.props}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export class EventDetailsCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      format: [],
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;

    return (
      <div className="outcome-admin-types">
        <div>
          <Modal
            open={modal}
            onOpen={() => this.toggle()}
            closeIcon={
              <Icon
                onClick={() => this.toggle()}
                name="close"
                className="closeicon"
              />
            }
            size="small"
            trigger={
              <Button className="Primary-Button">
                <div className="add-icon-activity-add">
                  <Icon name="plus circle" />
                  <div className="add-text">
                    {t(
                      'admin.activity_settings.activity_types.add_activity_type'
                    )}
                  </div>
                </div>
              </Button>
            }
            className="create-activity-type"
          >
            <Modal.Header>
              {t('admin.activity_settings.activity_types.create_activity_type')}
            </Modal.Header>
            <Modal.Content>
              <ActivityForm
                isEdit={false}
                toggle={() => this.toggle()}
                {...this.props}
              />
            </Modal.Content>
          </Modal>
        </div>
      </div>
    );
  }
}

class ActivityForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      definition: '',
      definitionError: false,
      format: [],
      outputFormatId: '',
      isActive: true,
    };
  }

  componentWillMount() {
    const { form } = this.props;

    this.setState({
      definition: get(form, 'definition', ''),
    });
  }

  componentDidMount() {
    const { outputFormatGroupsList, form, isEdit } = this.props;

    if (!isEdit) return null;

    const formatObj = find(outputFormatGroupsList.docs, {
      id: form.outputFormatId,
    });

    const formatList = [];
    formatObj.outputFormat.forEach((format) => {
      formatList.push(format.formatDetails);
    });

    this.setState({
      isActive: form.isActive,
    });

    if (!isEmpty(formatObj)) {
      this.setState({
        format: formatList,
      });
    }
  }

  selectActivityType() {
    const { eventTypes } = this.props;
    return map(eventTypes, (item, i) => {
      return (
        <option key={i} value={item.id}>
          {item.type}
        </option>
      );
    });
  }
  selectOutputFormatters() {
    const { outputFormatGroupsList } = this.props;
    return map(outputFormatGroupsList.docs, (item, i) => {
      return (
        <option key={i} value={item.id}>
          {item.name}
        </option>
      );
    });
  }

  onChangeOutputFormatter(value) {
    const { outputFormatGroupsList } = this.props;

    let formatId = parseInt(value);

    const formatObj = find(outputFormatGroupsList.docs, { id: formatId });

    const formatList = [];
    formatObj.outputFormat.forEach((format) => {
      formatList.push(format.formatDetails);
    });

    if (!isEmpty(formatObj)) {
      this.setState({
        format: formatList,
      });
    }
  }

  renderOutputFormatter() {
    const { format } = this.state;
    return (
      <ul className="ul-col">
        {map(format, (item, i) => {
          return <li key={i}>{item.label}</li>;
        })}
      </ul>
    );
  }

  async handleValidSubmit(event, values) {
    const { t } = this.props;
    try {
      const { definition, isActive } = this.state;
      const { postActivityType, toggle, isEdit, updateActivityType, form } =
        this.props;

      if (isEmpty(definition)) {
        this.setState({
          definitionError: true,
        });
      } else {
        values.isActive = isActive;
        const data = { ...values, definition };

        if (isEdit) {
          values.definition = definition;
          await updateActivityType(form.id, values);
          toggle();
        } else {
          await postActivityType(data);
          toggle();
        }
      }
    } catch (error) {
      console.error(t('admin.system_logs.handle_submit_activity_type'), error);
    }
  }

  render() {
    const { toggle, activityLoading, isEdit, form, activityUpdateLoading, t } =
      this.props;

    const { definition, definitionError, format, isActive } = this.state;

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
        model={isEdit ? form : null}
      >
        <AvField
          label={t('common.title')}
          className="org-inputs"
          name="detail"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.title_required'),
            },
          }}
        />
        <div className="gap-activity">
          <label>{t('common.description')}</label>

          <CKEditor
            editor={ClassicEditor}
            config={{
              plugins: [Essentials, Bold, Italic, List, Heading, Paragraph],
            }}
            data={definition}
            onBlur={(event, editor) => {
              const definition = editor.getData();
              this.setState({
                definition,
              });
            }}
          />
        </div>
        {definitionError ? (
          <div className="custom-error-label">
            {t('formulary.validation.description_required')}
          </div>
        ) : null}

        <div className="gap-activity">
          <AvField
            label={t('common.activity_type')}
            className="org-inputs"
            name="eventType"
            type="select"
            validate={{
              required: {
                value: true,
                errorMessage: t('formulary.validation.activity_type_required'),
              },
            }}
          >
            <option value="" disabled defaultValue>
              {t('formulary.placeholder.select_activity_type')}
            </option>
            {this.selectActivityType()}
          </AvField>
        </div>

        <div className="gap-activity">
          <AvField
            label={t('formulary.output_formatter')}
            className="org-inputs"
            name="outputFormatId"
            type="select"
            disabled={isEdit}
            onChange={(e) => this.onChangeOutputFormatter(e.target.value)}
            validate={{
              required: {
                value: true,
                errorMessage: t(
                  'formulary.validation.output_formatter_required'
                ),
              },
            }}
          >
            <option value="" disabled defaultValue>
              {t('formulary.placeholder.select_output_formatter')}
            </option>
            {this.selectOutputFormatters()}
          </AvField>
        </div>

        {format && format.length ? (
          <div>
            <label>
              {t('admin.activity_settings.activity_types.output_fields')}
            </label>
            {this.renderOutputFormatter()}
          </div>
        ) : null}

        <div className="activate-notify-row">
          <div className="evaluation-activity-toggel-group mt-4">
            <label className="lbl-margin-left mb-0">
              {t('common.active')}{' '}
            </label>
            <Radio
              toggle
              name="isActive"
              checked={isActive}
              onChange={() => {
                this.setState({ isActive: !isActive });
              }}
            />
          </div>
        </div>

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={isEdit ? t('actions.save') : t('actions.create')}
            type="submit"
            className="Primary-Button"
            loading={isEdit ? activityUpdateLoading : activityLoading}
            disabled={isEdit ? activityUpdateLoading : activityLoading}
          />
        </div>
      </AvForm>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activityType: state.admin.activityType,
    eventTypes: state.extra.eventTypes,
    outputFormatGroupsList: state.admin.outputFormatGroupsList,
    activityLoading: state.admin.activityLoading,
    activityUpdateLoading: state.admin.activityUpdateLoading,
    eventDetails: state.extra.eventDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getEventTypes,
      getOutputFormatGroups,
      postActivityType,
      getEventDetails,
      updateActivityType,
    },
    dispatch
  );
};

ParentEventDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ParentEventDetails));

export { ParentEventDetails };
